import React from 'react';
import { Edit } from 'react-admin';
import CourseInstanceInputs from './CourseInstanceInputs';
import dayjs from 'dayjs';
import { EditToolbar } from '../../layout/EditToolbar';

const transform = async (data) => {
    const yearsAndDates = data.yearsAndDates.map((y) => {
        return {
            ...y,
            startDate: dayjs(y.startDate).set('date', 2).toISOString(),
            endDate: dayjs(y.endDate).endOf('month').toISOString(),
        };
    });

    return {
        ...data,
        yearsAndDates: yearsAndDates,
    };
};

const CourseInstanceEdit = (props) => (
            <Edit {...props} redirect="edit" transform={transform} >
                <CourseInstanceInputs isCreate={false} {...props} />
            </Edit>
);

export default CourseInstanceEdit;
